import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormattedHTMLMessage, injectIntl } from 'react-intl'
import { Helmet } from 'react-helmet-async'

import FormattedMessage from '../../../components/FormattedMessage/FormattedMessage'
import faqActions from '../../../redux/actions/faq.actions'
import Loader from '../../../components/Loader/Loader'

import FaqItemDetails from '../../../components/Faq/FaqElasticSearch/FaqItemDetails'
import FaqVoteModal from '../../../components/Faq/FaqElasticSearch/FaqVoteModal'
import NotFound from '../../NotFound/NotFound'
import faqService from '../../../services/faq.service'
import stripHTMLFormatter from '../../../utilities/stripHTMLStringFormatter'

class FaqItemDetailsContainer extends Component {
  constructor() {
    super()
    this.state = {
      searchString: '',
      modalOpen: false,
    }
  }

  async componentDidMount() {
    const {
      getFaqs,
      getFaqsCategories,
      getRelatedFaq,
      match: {
        params: { faqId, faqCategory },
      },
      location: { pathname },
    } = this.props
    await getFaqs()
    await getRelatedFaq(`${faqCategory}/${faqId}`)
    await getFaqsCategories()
    this.saveUserFaqHistory(faqId)

    if (typeof window.gtag === 'function') {
      window.gtag('config', 'UA-22122468-1', {
        page_path: pathname,
      })
      window.gtag('event', 'page_view', {
        page_path: pathname,
      })
    }
  }

  handleFaqVoteFormSubmit = values => {
    const { lastCreatedFaqVoteResponse, saveFaqVoteModalFeedback } = this.props
    const { feedbackResponse } = values

    const filteredDescription = stripHTMLFormatter(feedbackResponse)
    const payload = {
      ...lastCreatedFaqVoteResponse,
      description: filteredDescription,
    }

    if (filteredDescription.length > 0) {
      saveFaqVoteModalFeedback(payload)
    }
  }

  // Show modal if down voted
  handleFaqDownVoteResponse() {
    this.toggleModal()
  }

  toggleModal = () => {
    this.setState(state => ({
      modalOpen: !state.modalOpen,
    }))
  }

  saveUserFaqHistory(faqId) {
    const { faqs, setFaqUserHistory } = this.props
    if (!Array.isArray(faqs)) return
    const faq = faqs.filter(item => item.faqId === parseInt(faqId, 10))
    const lastFaqCategoryId = Array.isArray(faq) && faq.length > 0 && faq[0].category.id
    const payload = {
      id: lastFaqCategoryId,
    }
    setFaqUserHistory(payload)
  }

  filterFaq(faqs) {
    if (!Array.isArray(faqs)) return []
    const {
      match: {
        params: { faqId },
      },
    } = this.props
    if (!Array.isArray(faqs)) return
    const faq = faqs.filter(item => item.faqId === parseInt(faqId, 10))
    return faq
  }

  render() {
    const {
      faqs,
      faqLoading,
      intl,
      faqRelated,
      getRelatedFaq,
      setFaqScore,
      match: {
        params: { faqId },
      },
    } = this.props
    const { modalOpen } = this.state
    const pageTitleLabel = intl.formatMessage({ id: 'global.pageTitles.faq' })

    if (!faqLoading && !faqService.findFaqById(faqs, faqId)) {
      return <NotFound />
    }

    return (
      <div className="container mt-5 mb-5" aria-labelledby="faq-page-title">
        <Helmet>
          <title>{pageTitleLabel}</title>
        </Helmet>
        <h1 className="page-title" id="faq-page-title">
          <FormattedMessage id="page.faqPage.title.heroTitle" />
        </h1>
        <h4>
          <FormattedMessage id="page.faqPage.title.description" />
        </h4>
        <p>
          <FormattedHTMLMessage id="page.faqPage.title.note" />
        </p>

        {faqLoading ? (
          <Loader />
        ) : (
          <>
            <FaqVoteModal
              isOpen={modalOpen}
              toggle={this.toggleModal}
              handleSubmit={this.handleFaqVoteFormSubmit}
            />
            <FaqItemDetails
              faqsArticle={faqRelated}
              getRelatedFaq={getRelatedFaq}
              faq={this.filterFaq(faqs)[0]}
              handleScoring={setFaqScore}
              handleFaqDownVoteResponse={() => this.handleFaqDownVoteResponse()}
            />
          </>
        )}
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  getFaqs: () => dispatch(faqActions.getFaqs()),
  getFaqsCategories: () => dispatch(faqActions.getFaqsCategories()),
  getRelatedFaq: pathname => dispatch(faqActions.getRelatedFaq(pathname)),
  setFaqScore: (...args) => dispatch(faqActions.setFaqScore(...args)),
  setFaqUserHistory: (...args) => dispatch(faqActions.saveUserFaqHistory(...args)),
  saveFaqVoteModalFeedback: (...args) => dispatch(faqActions.saveFaqVoteModalFeedback(...args)),
})

const mapStateToProps = state => ({
  faqLoading: state.faqReducer.faqLoading,
  faqs: state.faqReducer.faq,
  faqRelated: state.faqReducer.faqRelated,
  faqCategories: state.faqReducer.faqCategories,
  lastCreatedFaqVoteResponse: state.faqReducer.lastCreatedFaqVoteResponse,
})

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(FaqItemDetailsContainer))
